import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CheckinLogSection } from 'src/app/core/graphql/generated/gen-types';
import { FlightService } from 'src/app/core/services/flight/flight.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// 112: read-only view of the append-only mobile check-in change log of one flight
@Component({
	selector: 'app-checkin-log-card',
	templateUrl: './checkin-log-card.component.html',
	styleUrls: ['./checkin-log-card.component.scss'],
})
export class CheckinLogCardComponent implements OnInit, OnDestroy {
	@Input() flightId: string;

	logs = [];
	signoffSection = CheckinLogSection.Signoff;
	private destroy$ = new Subject<void>();

	private static readonly PARAMETER_LABELS = {
		hour: 'FLIGHTS.takeoffTime',
		comment: 'FLIGHTS.comment',
		tempTakeoff: 'FLIGHTS.temp_takeoff',
		windGl: 'FLIGHTS.wind_gl',
		windGlDirection: 'FLIGHTS.wind_gl_direction',
		weatherQnh: 'FLIGHTS.weather_qfe',
		plannedFlightTime: 'FLIGHTS.planned_flight_time',
		maximumFlightTime: 'FLIGHTS.maximum_flight_time',
		tempBalloon: 'FLIGHTS.balloon_temp',
		weight: 'BOOKINGS.weight',
	};

	private static readonly PARAMETER_UNITS = {
		tempTakeoff: '°C',
		windGl: 'KT',
		windGlDirection: '°',
		weatherQnh: 'hPa',
		plannedFlightTime: 'min',
		maximumFlightTime: 'min',
		tempBalloon: '°C',
		weight: 'kg',
	};

	constructor(private flightService: FlightService) {}

	ngOnInit(): void {
		if (this.flightId) {
			this.flightService
				.getFlightCheckinLogs(this.flightId)
				.valueChanges.pipe(takeUntil(this.destroy$))
				.subscribe((result) => {
					this.logs = result.data?.flight?.checkinLogs ?? [];
				});
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	labelKey(parameter: string): string {
		return CheckinLogCardComponent.PARAMETER_LABELS[parameter] ?? parameter;
	}

	unit(parameter: string): string {
		return CheckinLogCardComponent.PARAMETER_UNITS[parameter] ?? '';
	}
}
